import Axios from "./axios";

import {
    ONCHANGEPASSWORD,
    ONCOUNTNOTIFICATION,
    ONDELETENOTIFICATION,
    ONEDDITPROFILE,
    ONFACEBOOKLOGIN,
    ONFAQCATEGORIES,
    ONFECTHUSERPOSTMESSAGE,
    ONGETCOUNTRIESLEAGUES,
    ONGETCOUNTRIESLIST,
    ONGETFAQ,
    ONGETFETCHSPORTS,
    ONGETMATCHLIST,
    ONLOGIN,
    ONMYPROFILE,
    ONREGISTER,
    ONRESETPASSWORD,
    ONSEENNOTIFICATION,
    ONUPDATEPROFILE,
    ONUPDATEPROFILEIMAGE,
    ONUSERACADEMY,
    ONUSERACADEMYDETAILS,
    ONUSERAWARDS,
    ONUSERAWARDSAPI,
    ONUSERAWARDSDETAILS,
    ONUSERAWARDSSEARCH,
    ONUSERBETSSPORTS,
    ONUSERCONTACTUS,
    ONUSEREDITPROFILEOTHER,
    ONUSERFRIENDLIST,
    ONUSERMESSAGE,
    ONUSERMYBETS,
    ONUSERMYTRANSACTION,
    ONUSERNOTIFICATION,
    ONUSERPOSTMESSAGE,
    ONUSERPOSTMESSAGEDELETE,
    ONUSERREDEEM,
    ONUSERRELOADBALANCE,
    ONUSERREMOVEPROFILE,
    ONUSERREQUESTWITHDRAW,
    ONUSERSETTINGPERFERENCE,
    ONUSERSUBMISSION,
    ONUSERUPDATEPROFILEOTHER,
    ONUSERUPDATESETTINGPERFERENCE, UPDATE_MATCH_ODDS,
} from "./type";
import { toast } from "react-toastify";

const config = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem("userToken")}`,
  },
};

export const onRegister = (data, setLoader, navigate) => (dispatch) => {
  Axios.post("auth/register", data)
    .then((res) => {
      setLoader(false);

      if (res.data.status === 'success' || res.status === 201) {
        toast.success(res.data.message);
        dispatch(onLogin({ email: data.email, password: data.password }, navigate, setLoader));
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONREGISTER,
        payload: res,
      });
    })
    .catch((err) => {
      setLoader(false);
      if (err.response?.data?.errors) {
        Object.values(err.response.data.errors).forEach(error => {
          toast.error(error[0]);
        });
      } else if (err.response?.data?.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error("An error occurred during registration");
      }
    });
};
export const onLogin = (data, navigate, setLoader) => (dispatch) => {
  Axios.post("auth/login", data)
    .then((res) => {
      setLoader(false);

      if (res.data.status === 'success') {
        toast.success(res.data.message);
        localStorage.setItem("userToken", res.data.token);
        localStorage.setItem("userDetails", JSON.stringify(res.data.user));

        navigate("/");

        window.location.reload();
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONLOGIN,
        payload: res.data,
      });
    })
    .catch((err) => {
      setLoader(false);
      if (err.response?.data?.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error("An error occurred during login");
      }
    });
};

export const onFaceBookLogin = (data, navigate, setLoader) => (dispatch) => {
  Axios.post("auth/social-login", data)
    .then((res) => {
      setLoader(false);

      if (res.data.status === 'success') {
        toast.success(res.data.message);
        localStorage.setItem("userToken", res.data.result.jwt_token);
        localStorage.setItem("userDetails", JSON.stringify(res.data.result));
        navigate("/");
        window.location.reload();
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONFACEBOOKLOGIN,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const onResetPassword = (data) => (dispatch) => {
  Axios.post("auth/forgot-password", data)
    .then((res) => {
      if (res.data.status === 'success') {
        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
      }
      toast.success(res.data.message);
      dispatch({
        type: ONRESETPASSWORD,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onChangePassword = (data) => async (dispatch) => {
  try {
    const response = await Axios.put("/auth/update-password", data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("userToken")}`
      }
    });
    if (response.data.status) {
      toast.success(response.data.message);
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Something went wrong");
  }
};
export const onUpdateProfile = (data) => (dispatch) => {
  Axios.put("/profile", data, config)
    .then((res) => {
      if (res.data.status === 'success') {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONUPDATEPROFILE,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response?.data) {
        dispatch({
          type: ONUPDATEPROFILE,
          payload: err.response.data,
        });
      }
    });
};
export const onUpdateProfileImage = (data) => (dispatch) => {
  Axios.post("/auth/update-profile-image", data, config)
    .then((res) => {
      if (res.data.status === 'success') {
        toast.success("your image change successfully");
      }

      dispatch({
        type: ONUPDATEPROFILEIMAGE,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onDeleteNotification = (data) => (dispatch) => {
  Axios.post("/userdeletenotifications", data, config)
    .then((res) => {
      if (res.data.status === 'success') {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONDELETENOTIFICATION,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onUserFriendList = (data) => (dispatch) => {
  Axios.post("/userfriendlist", data, config)
    .then((res) => {
      dispatch({
        type: ONUSERFRIENDLIST,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onUserNotification = (data, setLoader) => (dispatch) => {
  Axios.post("/usernotifications", data, config)
    .then((res) => {
      setLoader(false);
      dispatch({
        type: ONUSERNOTIFICATION,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onSeenNotification = (data) => (dispatch) => {
  Axios.post("/seennotifications", data, config)
    .then((res) => {
      dispatch({
        type: ONSEENNOTIFICATION,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onCountNotification = (data) => (dispatch) => {
  Axios.post("/countnotification", data, config)
    .then((res) => {
      dispatch({
        type: ONCOUNTNOTIFICATION,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onMyProfile = (data) => (dispatch) => {
  Axios.post("/auth/my-profile", data, config)
    .then((res) => {
      dispatch({
        type: ONMYPROFILE,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      if (err?.response?.data?.error === "invalid_token") {
        localStorage.removeItem("userToken");
        localStorage.removeItem("userDetails");
      }
    });
};
export const onEditProfile = (data) => (dispatch) => {
  Axios.post("/auth/edit-profile", data, config)
    .then((res) => {
      dispatch({
        type: ONEDDITPROFILE,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getFixturesListByLeague = (leagueId) => (dispatch) => {
  Axios.get(`/leagues/${leagueId}/fixtures`, config)
    .then((res) => {
      dispatch({
        type: ONGETMATCHLIST,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getFixturesListBySport = (sportId) => (dispatch) => {
  Axios.get(`/sports/${sportId}/fixtures`, config)
    .then((res) => {
      dispatch({
        type: ONGETMATCHLIST,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getAllFixtures = () => (dispatch) => {
  Axios.get(`/fixtures`, config)
    .then((res) => {
      dispatch({
        type: ONGETMATCHLIST,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onUpdateMatchOdds = (updatedOdds) => {
    return {
        type: UPDATE_MATCH_ODDS,
        payload: updatedOdds,
    };
};
export const onGetCountriesLeagues = (regionId) => (dispatch) => {
    Axios.get(`/regions/${regionId}/leagues`, config)
    .then((res) => {
      dispatch({
        type: ONGETCOUNTRIESLEAGUES,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onGetCountriesList = (data) => (dispatch) => {
  Axios.get("/countries", config)
    .then((res) => {
      dispatch({
        type: ONGETCOUNTRIESLIST,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onFetchSports = (setLoader) => (dispatch) => {
  Axios.get("/sports/enabled", config)
    .then((res) => {
      setLoader(false);
      dispatch({
        type: ONGETFETCHSPORTS,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onFaqCategories = (setLoader) => (dispatch) => {
  Axios.get("/frequently-asked-questions/categories", config)
    .then((res) => {
      setLoader(false);
      dispatch({
        type: ONFAQCATEGORIES,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onGetFaq = (setLoader) => (dispatch) => {
  Axios.get('/frequently-asked-questions', config)
    .then((res) => {
      setLoader(false);
      dispatch({
        type: ONGETFAQ,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
      setLoader(false);
    });
};
export const onUserSettingPreference = (data) => (dispatch) => {
  Axios.post("/userpreferences", data, config)
    .then((res) => {
      dispatch({
        type: ONUSERSETTINGPERFERENCE,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onUserUpdateSettingPreference =
  (data, setLoader) => (dispatch) => {
    Axios.post("/udateduserpreferences", data, config)
      .then((res) => {
        setLoader(false);
        if (res.data.status === 'success') {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
        dispatch({
          type: ONUSERUPDATESETTINGPERFERENCE,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const onUserAwards = (data, setLoader) => (dispatch) => {
  Axios.get("/prizes", { 
    params: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("userToken")}`,
    }
  })
    .then((res) => {
      setLoader(false);
      dispatch({
        type: ONUSERAWARDS,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
      setLoader(false);
    });
};
export const onUserAwardsDetails = (data, setLoader) => (dispatch) => {
  Axios.get(`/prize-details/${data.awards_id}`, {
    params: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("userToken")}`,
    }
  })
    .then((res) => {
      setLoader(false);
      dispatch({
        type: ONUSERAWARDSDETAILS,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
      setLoader(false);
    });
};

export const onUserAcademy = (setLoader) => (dispatch) => {
  Axios.get("/articles", config)
    .then((res) => {
      setLoader(false);
      dispatch({
        type: ONUSERACADEMY,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
      setLoader(false);
    });
};

export const onUserAcademyDetails = (slug, setLoader) => (dispatch) => {
  Axios.get(`/articles/${slug}`, config)
    .then((res) => {
      setLoader(false);
      dispatch({
        type: ONUSERACADEMYDETAILS,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
      setLoader(false);
    });
};

export const onUserPostMessage = (data, setMessage, setImage) => (dispatch) => {
  Axios.post("/postmessage", data, config)
    .then((res) => {
      if (res.data.status === 'success') {
        toast.success(res.data.message);
        setMessage("");
        setImage("");
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONUSERPOSTMESSAGE,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onFetchUserPostMessage = (data, setLoader) => (dispatch) => {
  Axios.post("/fetchpostmessage", data, config)
    .then((res) => {
      setLoader(false);
      dispatch({
        type: ONFECTHUSERPOSTMESSAGE,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onUserPostMessageDelect = (data) => (dispatch) => {
  Axios.post("/postmessagedelete", data, config)
    .then((res) => {
      if (res.data.status === 'success') {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONUSERPOSTMESSAGEDELETE,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onUserBalance = (data) => (dispatch) => {
  Axios.post("/user/balance", data, config)
    .then((res) => {
      dispatch({
        type: ONUSERMESSAGE,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onUserReloadBalance = (data) => (dispatch) => {
  Axios.post("/reloaduserbalance", data, config)
    .then((res) => {
      if (res.data.status === 'success') {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONUSERRELOADBALANCE,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onUserRedeemAwards = (data) => (dispatch) => {
  Axios.post(`/prizes/${data.awards_id}/redeem`, data, config)
    .then((res) => {
      if (res.data.status === 'success' || res.data.status === true) {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONUSERREDEEM,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response && err.response.data && err.response.data.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error("An error occurred redeeming prize");
      }
      console.log(err);
    });
};

export const onUserMyTransaction = (data, setLoader) => (dispatch) => {
  Axios.post("/my-transactions", data, config)
    .then((res) => {
      setLoader(false);
      dispatch({
        type: ONUSERMYTRANSACTION,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onUserBetSport = (data, setTeamId, setAmount) => (dispatch) => {
  Axios.post("/bets", data, config)
    .then((res) => {
      if (res.data.status === 'success') {
        toast.success(res.data.message);
        setTeamId("");
        setAmount("");
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONUSERBETSSPORTS,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      if (err.response && err.response.data) {
        toast.error(err.response.data.message || 'Error al realizar la apuesta');
      } else {
        toast.error('Error al conectar con el servidor');
      }
      console.log(err);
    });
};
export const onUserRequestWithdraw = (data, setLoader) => (dispatch) => {
  Axios.post("/requestWithdraw", data, config)
    .then((res) => {
      setLoader(false);
      if (res.data.status === 'success') {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONUSERREQUESTWITHDRAW,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onUserMyBets = (data, setLoader) => (dispatch) => {
  Axios.post("/my-bets", data, config)
    .then((res) => {
      setLoader(false);
      console.log("API Response:", res.data);
      dispatch({
        type: ONUSERMYBETS,
        payload: res.data.data,
      });
    })
    .catch((err) => {
      console.log(err);
      setLoader(false);
    });
};
export const onUserAwardsSearch = (data, setLoader) => (dispatch) => {
  Axios.post("/awardsSearch", data, config)
    .then((res) => {
      setLoader(false);
      dispatch({
        type: ONUSERAWARDSSEARCH,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onUserUpdateProfileOther = (data, setLoader) => (dispatch) => {
  Axios.post("/updateprofileother", data, config)
    .then((res) => {
      setLoader(false);
      if (res.data.status === 'success') {
        toast.success(res.data.message);
        window.location.reload();
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONUSERUPDATEPROFILEOTHER,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const onUserEditProfileOther = (data, setLoader) => (dispatch) => {
  Axios.post("/auth/user-profile", data, config)
    .then((res) => {
      setLoader(false);
      dispatch({
        type: ONUSEREDITPROFILEOTHER,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const onUserAwardsApi = (data, setLoader) => (dispatch) => {
  Axios.post("/userawards", data, config)
    .then((res) => {
      setLoader(false);
      dispatch({
        type: ONUSERAWARDSAPI,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const onUserRemoveProfile = (data, setLoader) => (dispatch) => {
  Axios.post("/auth/remove-profile-image", data, config)
    .then((res) => {
      setLoader(false);
      if (res.data.status === 'success') {
        toast.success(res.data.message);
        window.location.reload();
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONUSERREMOVEPROFILE,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const onUserContactUs = (data, setLoader, setValue) => (dispatch) => {
  Axios.post("/contact-us", data, config)
    .then((res) => {
      toast.success(res.data.message);
      setValue({});
      setLoader(false);
      dispatch({
        type: ONUSERCONTACTUS,
        payload: res.data.result,
      });
    })
    .catch((err) => {
      console.log(err);
      setLoader(false);
    });
};

export const onUserOfferSubmission = (data, setEmail) => (dispatch) => {
  Axios.post("/newsletter", data, config)
    .then((res) => {
      if (res.data.status === 'success') {
        toast.success(res.data.message);
        setEmail("");
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONUSERSUBMISSION,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const onUpdatePassword = (data, navigate) => async (dispatch) => {
  try {
    const response = await Axios.post("/auth/reset-password", data);
    if (response.data.status === 'success') {
      toast.success(response.data.message);
      navigate("/login");
    } else {
      toast.error(response.data.message);
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Something went wrong");
  }
};

export const onLoginWithToken = (token, navigate, setLoader) => (dispatch) => {
  setLoader(true);
  Axios.post("auth/login-as", { token })
    .then((res) => {
      setLoader(false);

      if (res.data.status === 'success') {
        toast.success(res.data.message);
        localStorage.setItem("userToken", res.data.token);
        localStorage.setItem("userDetails", JSON.stringify(res.data.user));
        navigate("/");
        window.location.reload();
      } else {
        toast.error(res.data.message);
      }
      dispatch({
        type: ONLOGIN,
        payload: res.data,
      });
    })
    .catch((err) => {
      setLoader(false);
      toast.error(err.response?.data?.message || "An error occurred during auto login");
    });
};
